// Works out whether the wallet pass can go straight onto this device, or whether we're on
// the in-store kiosk and should show a QR code for the customer to scan with their phone.
//
// The user agent alone can't tell the kiosk apart from a phone: Chrome on Android tablets
// can report "Mobile" just like a phone. So we combine:
//  - ?kiosk=1   remembered on the device (localStorage) - always QR. ?kiosk=0 clears it.
//  - ?source=…  a tagged link from our comms (e.g. source=welcome-email), remembered for
//               the visit (sessionStorage) - the customer is on their own device.
//  - screen size: phones are phone-sized, the kiosk tablet isn't.
const KIOSK_KEY = 'shavesKiosk';
const TAGGED_KEY = 'shavesTaggedVisit';

// Narrow side of the screen in CSS pixels. Phones are ~320-430; tablets are larger.
const MAX_PHONE_WIDTH = 480;

function storage(type) {
    try {
        return window[type];
    } catch (e) {
        return null;
    }
}

export function rememberEntryFlags() {
    const search = window.location.search;
    const local = storage('localStorage');
    const session = storage('sessionStorage');
    try {
        if (local && /[?&]kiosk=1(&|$)/.test(search)) local.setItem(KIOSK_KEY, '1');
        if (local && /[?&]kiosk=0(&|$)/.test(search)) local.removeItem(KIOSK_KEY);
        if (session && /[?&]source=[^&]/.test(search)) session.setItem(TAGGED_KEY, '1');
    } catch (e) {
        // Storage unavailable (e.g. private mode) - fall back to screen-size detection
    }
}

export function isKiosk() {
    try {
        const local = storage('localStorage');
        return !!local && local.getItem(KIOSK_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function isTaggedVisit() {
    try {
        const session = storage('sessionStorage');
        return !!session && session.getItem(TAGGED_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function isPhoneSized() {
    return Math.min(window.screen.width, window.screen.height) < MAX_PHONE_WIDTH;
}
